import { getPatternStyles, patternFns } from './runtime.mjs';
import { memo } from '../helpers.mjs';
import { css } from '../css/index.mjs';

const visuallyHiddenConfig = { transform(props) {
  return {
    srOnly: true,
    ...props
  };
} }

export function visuallyHiddenRaw(styles) {
  const s = getPatternStyles(visuallyHiddenConfig, styles || {})
  return visuallyHiddenConfig.transform(s, patternFns)
}

export const visuallyHidden = /* @__PURE__ */ Object.assign(/* @__PURE__ */ memo(function visuallyHidden(styles = {}) {
  return css(visuallyHiddenRaw(styles))
}), { raw: visuallyHiddenRaw, propKeys: [] })